import React, { useEffect, memo, useState, useCallback } from 'react'
import ReactModal from 'react-modal'
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg'
import i18n from '../../i18n'
import Loading from '../Loading'
import { getContentPreviewTargets } from '../../server/server'
import { translateTargetText } from '../../utils/util'
import { ANALYTICS_EVENTS } from '../../analytics/events'
import useTrackedSurface from '../../analytics/useTrackedSurface'

const TargetPreviewModal = memo(({ modalIsOpen, closeModal, content = null, program = null }) => {
    const [loading, setLoading] = useState(true)
    const [targets, setTargets] = useState([])
    useTrackedSurface(ANALYTICS_EVENTS.DASHBOARD_CONTENT_RESULTS_TARGET_VIEWED, {
        active: modalIsOpen && !!content,
        contentId: content?.id,
        content: content?.title,
    })

    useEffect(() => {
        ReactModal.setAppElement('#root')
    }, [])

    useEffect(() => {
        let element = document.getElementById('home')
        if (modalIsOpen) {
            if (element != null) {
                element.style.filter = 'blur(5px)'
            }
        }
        return () => {
            if (element != null) {
                element.style.filter = 'unset'
            }
            setTargets([])
        }
    }, [modalIsOpen])

    const loadTargetPreview = useCallback(async () => {
        setLoading(true)
        const response = await getContentPreviewTargets({ contentId: content?.id, programId: program?.id })
        if (response?.status === 200) {
            setTargets(response.data ?? [])
        }
        setLoading(false)
    }, [content?.id, program?.id])

    useEffect(() => {
        if (modalIsOpen) {
            loadTargetPreview()
        }
    }, [modalIsOpen, loadTargetPreview])

    return (
        <ReactModal
            transparent
            isOpen={modalIsOpen}
            ariaHideApp={false}
            onAfterOpen={() => {}}
            onAfterClose={() => {}}
            onRequestClose={closeModal}
            style={{
                overlay: {
                    zIndex: 56,
                },
                content: {
                    inset: 0,
                    padding: 0,
                    opacity: 1,
                    margin: 'auto',
                    marginTop: 30,
                    // width: 900,
                    backgroundColor: 'transparent',
                    maxHeight: '95%',
                    border: 'none',
                    borderRadius: 10,
                    boxShadow: 'none',
                    overflow: 'hidden',
                    position: 'relative',
                },
            }}
        >
            <div className="absolute top-0 w-full flex items-center justify-center ">
                <div
                    className="w-[60px] h-[60px] bg-deepPurple rounded-full cursor-pointer flex items-center justify-center z-[2] hover:bg-darkenPurple "
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        closeModal()
                    }}
                >
                    <CloseModalIcon />
                </div>
            </div>
            <div className={`mt-[30px] flex flex-col gap-[10px] bg-white min-h-[50vh] w-[500px] max-h-[80vh] mx-auto rounded-xl p-[20px] `}>
                <h1 className="font-bold text-[26px] mt-[10px] text-darkPurple text-center w-full">{i18n.t('Target preview')}</h1>
                <h1 className=" text-[14px] mt-[10px] text-darkPurple text-center w-full">{i18n.t('This content is visible to the following groups:')}</h1>
                <div className={`flex-1 flex-col w-full flex ${loading ? 'items-center justify-center' : 'overflow-y-scroll'} `}>
                    {loading ? (
                        <Loading />
                    ) : (
                        <ul className="flex flex-col gap-[8px] w-full">
                            {targets.length === 0 ? (
                                <p className="text-center text-gray-400">{i18n.t('No targets found')}</p>
                            ) : (
                                targets.map((target, index) => (
                                    <li key={target.id ?? index} className="p-[10px]  rounded-lg text-darkPurple capitalize">
                                        <span className="text-darkPurple">▸</span> {translateTargetText(target)}
                                    </li>
                                ))
                            )}
                        </ul>
                    )}
                </div>
            </div>
        </ReactModal>
    )
})

export default TargetPreviewModal
